import { API_CONFIG, API_LIST } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'
import { useAppDispatch } from '../../Store/Hooks'
import { showAlert } from '../../Store/Slice/alert.slice'
import { setLoader } from '../../Store/Slice/loader.slice'
import { PlayIcon } from '../Icons'
import ChipButton from '../Shared/ChipButton'
import { useDialog } from '../Shared/Dialog/DialogContext'
import MUITooltip from '../Shared/MUI-Tooltip'
import VideoJS from '../VideoPlayer/VideoPlayer'

const path =
  'low_res_video_files/ACA_Crunchyroll-E00051117A00248050-Full-Mezz_HD-ja-JP_ACASIM0034_J7541452.mp4'

interface PlayProps {
  item: {
    videoFilePath?: string
  }
}

const CommonListingReportActionPlay = ({ item }: PlayProps) => {
  const showDialog = useDialog()
  const dispatch = useAppDispatch()

  const showPlayerDialog = async () => {
    try {
      const urlPath = item?.videoFilePath || path

      if (!urlPath) {
        dispatch(showAlert([true, 'Video file path not found.', 'error']))
        return
      }

      dispatch(setLoader(true))

      const apiRes = await mainApiService(
        API_CONFIG(API_LIST.REPORTS.GET_PRESIGNED_STREAMING_URL, null, {
          key: urlPath,
        }),
      )

      if (!apiRes?.data?.url) {
        dispatch(showAlert([true, 'Failed to fetch streaming URL.', 'error']))
        return
      }

      const videoSource = [
        {
          src: apiRes.data.url,
          type: 'video/mp4',
        },
      ]

      showDialog('confirm', {
        width: '800px',
        icon: '',
        title: '',
        extraUI: (
          <div style={{ marginBottom: '24px' }}>
            <VideoJS source={videoSource} playBackRates={[0.5, 0.75, 1, 1.25, 1.5, 2]} />
          </div>
        ),
        btn1Label: 'Close',
        onClose: () => undefined,
      })
    } catch (error) {
      dispatch(showAlert([true, 'Error fetching streaming URL.', 'error']))
    } finally {
      dispatch(setLoader(false))
    }
  }

  const handlePlayClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    showPlayerDialog()
  }

  return (
    <div
      onClick={handlePlayClick}
      className='cursor-pointer'
      data-testid='edit__chip-btn'
      style={{
        width: 'fit-content',
        opacity: 1,
      }}
    >
      <MUITooltip title='Play' disableInteractive>
        <span>
          <ChipButton
            type='primary'
            style={{
              gap: 0,
              padding: '14px 8px',
              boxShadow: '0px 1px 3px 0px #0000001A',
              border: '1px solid #E5E7EB',
              background: '#fff',
            }}
            label=''
            iconTooltip='Play'
            Icon={PlayIcon as any}
          />
        </span>
      </MUITooltip>
    </div>
  )
}

const SNPReviewReportActionBtn = (rowData: any) => {
  return (
    <div className='d-flex align-items-center'>
      <CommonListingReportActionPlay item={rowData} />
    </div>
  )
}

export default SNPReviewReportActionBtn
